require("./store.js")
const { AppDispatcher } = require("@cirrus/legacy/app-common/dispatcher")

;("use strict")

module.exports = {
  goBack: function () {
    AppDispatcher.dispatch({
      type: "GO_BACK:MANUAL",
    })
  },
  onBreadcrumbsChanged: function (data) {
    AppDispatcher.dispatch({
      type: "GO_BACK:BREADCRUMBS_CHANGED",
      data: {
        bc: data,
        editable: null,
      },
    })
  },
  changePageEditable: function (data) {
    AppDispatcher.dispatch({
      type: "GO_BACK:PAGE_EDITABLE",
      data: {
        editable: data,
        hidden: true,
      },
    })
  },
  removeBackButton: function () {
    AppDispatcher.dispatch({
      type: "GO_BACK:REMOVE_BACK_BUTTON",
      data: {
        bc: null,
        editable: null,
        backButton: "",
      },
    })
  },
  customTrigger: function (data) {
    AppDispatcher.dispatch({
      type: "GO_BACK:CUSTOM_TRIGGER",
      data: {
        editable: true,
        trigger: data,
      },
    })
  },
  hide: function () {
    AppDispatcher.dispatch({
      type: "GO_BACK:CHANGE_VISIBILITY",
      data: {
        hidden: true,
        backButton: "",
      },
    })
  },
  show: function (backText) {
    AppDispatcher.dispatch({
      type: "GO_BACK:CHANGE_VISIBILITY",
      data: {
        hidden: false,
        backText: backText,
      },
    })
  },
  resetVisibility: function () {
    AppDispatcher.dispatch({
      type: "GO_BACK:RESET_VISIBILITY",
      data: {
        hidden: false,
      },
    })
  },
  updateBackText: function (backText) {
    AppDispatcher.dispatch({
      type: "GO_BACK:UPDATE_BACK_TEXT",
      data: {
        backText: backText,
      },
    })
  },
}
